import React, { useState } from "react";
import axios from "axios";
import { baseurl } from "../../constant";

const UpiQronlyApiDocument = ({ upiCallbackUrl }) => {
  const [data, setdats] = useState();
  const [url, setUrl] = useState();

  const token = localStorage.getItem("authToken");

  const submitCallbackurl = async () => {
    const result = await axios.post(baseurl + "callbackUpdateAuth", {
      token: token,
      type: 2,
      url: url,
    });
    setdats(result.data);
  };

  return (
    <div>
      <div className="card shadow mb-4">
        <form
          id="admin_profile"
          enctype="multipart/form-data"
          method="post"
          accept-charset="utf-8"
        />
        <input type="hidden" name="method" value="post" />
        <div className="card-header py-3">
          {data && (
            <h4
              style={{
                backgroundColor: "#d2f4e8",
                borderColor: "#bff0de",
                color: "green",
              }}
            >
              {data.message}
            </h4>
          )}
          <div className="row">
            <div className="col-sm-8">
              <h4>
                <b>UPI QR Only API Document</b>
              </h4>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-sm-12">
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="bankListApi-tab"
                    data-toggle="tab"
                    href="#bankListApi"
                    role="tab"
                    aria-controls="bankListApi"
                    aria-selected="true"
                  >
                    Generate QR API
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="callBack-tab"
                    data-toggle="tab"
                    href="#callBack"
                    role="tab"
                    aria-controls="callBack"
                    aria-selected="false"
                  >
                    Call Back URL
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="checkStatus-tab"
                    data-toggle="tab"
                    href="#checkStatus"
                    role="tab"
                    aria-controls="checkStatus"
                    aria-selected="true"
                  >
                    Status Check API
                  </a>
                </li>
              </ul>
              <div className="tab-content apidoc" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="bankListApi"
                  role="tabpanel"
                  aria-labelledby="bankListApi-tab"
                >
                  <div className="col-sm-12">
                    <br />
                    <h1>Request API URL</h1>
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      https://www.payol.in/portal/api/generateQrAuth?memberid=
                      {"{memberid}"}&txnpwd={"{txnpwd}"}&name={"{name}"}&email=
                      {"{email}"}&mobile={"{mobile}"}&amount={"{amount}"}&txnid=
                      {"{txnid}"}
                    </p>
                    <hr />
                    <p>
                      <b>Request Method - GET</b>
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    <table class="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <th>#</th>

                          <th>Parameter Key</th>

                          <th>Description</th>
                        </tr>

                        <tr>
                          <td>1.</td>

                          <td>memberid</td>

                          <td>Your account unique id.</td>
                        </tr>

                        <tr>
                          <td>2.</td>

                          <td>txnpwd</td>

                          <td>Your account trasaction password.</td>
                        </tr>

                        <tr>
                          <td>3.</td>

                          <td>name</td>

                          <td>
                            QR Map Name Which will show after scan qr code
                          </td>
                        </tr>

                        <tr>
                          <td>4.</td>

                          <td>email</td>

                          <td>Customer Email </td>
                        </tr>

                        <tr>
                          <td>5.</td>

                          <td>mobile</td>

                          <td>Customer Mobile No.</td>
                        </tr>

                        <tr>
                          <td>6.</td>

                          <td>amount</td>

                          <td>Amount</td>
                        </tr>

                        <tr>
                          <td>7.</td>

                          <td>txnid</td>

                          <td>
                            Unique Transaction ID, Minimum Length Should be 10
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>JSON Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      {"{"}
                      <br />
                      "status_code": 200,
                      <br />
                      "status_msg": "QR Generated Successfully.",
                      <br />
                      "status": "SUCCESS",
                      <br />
                      "qr": "upi://pay?pa="------",
                      <br />
                      "txnID": "12356445645"
                      <br />
                      {"}"}
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>Response Parameters</h1>
                    <table className="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>status_code</td>
                        <td>
                          400 = Variable Related Error <br />
                          401 = Variable Data Related Error <br />
                          200 = Success
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>qr</td>
                        <td>QR Code String</td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>txnID</td>
                        <td>QR Reference ID</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="callBack"
                  role="tabpanel"
                  aria-labelledby="callBack-tab"
                >
                  <div className="col-sm-12">
                    <br />
                    <h1>Update Callback URL</h1>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="call_back_url"
                        placeholder={upiCallbackUrl}
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                      />
                      <p>Ex: https://www.yourwebsite.com/index.php?</p>
                    </div>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={submitCallbackurl}
                      >
                        Save
                      </button>
                    </div>
                    <hr />
                    <p>
                      <b>Request Method - POST Json Format</b>
                    </p>
                  </div>
                  <div className="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    For success -{"{"}{" "}
                    "status":"200","payerAmount":"100","payerName":"Test","txnID":"1234565465","BankRRN":"123564654564","payerVA":"0000000000@ybl","TxnInitDate":"20220608131419","TxnCompletionDate":"20220608131422"
                    {"}"} <br />
                    for Fail - {"{"}{" "}
                    status":"401","payerAmount":"100","payerName":"Test","txnID":"1234565465","BankRRN":"123564654564","payerVA":"0000000000@ybl","TxnInitDate":"20220608131419","TxnCompletionDate":"20220608131422"
                    {"}"}
                  </div>
                </div>

                <div
                  className="tab-pane fade show"
                  id="checkStatus"
                  role="tabpanel"
                  aria-labelledby="checkStatus-tab"
                >
                  <div className="col-sm-12">
                    <br />
                    <h1>Request API URL</h1>
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      https://www.payol.in/portal/api/payinCheckStatus
                    </p>
                    <hr />
                    <p>
                      <b>Request Method - POST</b>
                    </p>
                  </div>
                  <div className="col-sm-12">
                    <br />
                    <h1>Header Parameter</h1>
                    <table className="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>Memberid</td>
                        <td>Your account unique id.</td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>Txnpwd</td>
                        <td>Your account trasaction password.</td>
                      </tr>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>
                  <div className="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    <table className="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      {/* <!-- <tr>
                                           <td>1.</td>
                                           <td>mobile</td>
                                           <td>Customer Mobile No.</td>
                                         </tr> --> */}
                      <tr>
                        <td>1.</td>
                        <td>txnID</td>
                        <td>Your Unique Transcation ID</td>
                      </tr>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>JSON Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      {"{"}
                      <br />
                      "status_code": 200,
                      <br />
                      "status_msg": "OK",
                      <br />
                      "status": "SUCCESS",
                      <br />
                      "amount" : 100,
                      <br />
                      "txnid": 16131198309337,
                      <br />
                      "rrn" : 302111739646,
                      <br />
                      "opt_msg" : "Transaction Fetch Successfully"
                      <br />
                      {"}"}
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>Response Parameters</h1>
                    <table className="table table-bordered table-striped">
                      <tr>
                        <th>#</th>
                        <th>Parameter Key</th>
                        <th>Description</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>status_code</td>
                        <td>
                          400 = Variable Related Error <br />
                          401 = Variable Data Related Error <br />
                          200 = Success
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>status_msg</td>
                        <td>
                          API Success or Error Message according status code.
                        </td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>status</td>
                        <td>
                          PENDING <br />
                          FAILED <br />
                          SUCCESS
                        </td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>txnid</td>
                        <td>Your Unique Trasaction ID.</td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>rrn</td>
                        <td>rrn no from bank side.</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UpiQronlyApiDocument;
